"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportGiveawayExcel = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.fill.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.entries.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _fileSaver = require("file-saver");
var Excel = _interopRequireWildcard(require("exceljs"));
var _index = require("@/utils/index");
var _string = require("@/utils/string");
var _moment = _interopRequireDefault(require("moment"));
var _lodash = require("lodash");
var fontBold = {
  font: {
    bold: true
  }
};
var fontBoldRed = {
  font: {
    bold: true,
    color: {
      argb: "ffff0202"
    }
  }
};
var fontBoldGreen = {
  font: {
    bold: true,
    color: {
      argb: "ff427c27"
    }
  }
};
var border = {
  top: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  left: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  bottom: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  right: {
    style: "thin",
    color: {
      argb: "#000"
    }
  }
};
var row = 0;
var exportGiveawayExcel = exports.exportGiveawayExcel = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref) {
    var data, type, fromDate, toDate, fileName, workbook, worksheet, titleCell, startTableRow, startTable, newData, buffer, fileType, fileExtension, blob;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          data = _ref.data, type = _ref.type, fromDate = _ref.fromDate, toDate = _ref.toDate;
          // config export excel
          fileName = "Giveaway ".concat(type);
          workbook = new Excel.Workbook();
          worksheet = workbook.addWorksheet("Giveaway", {
            pageSetup: {
              fitToPage: true,
              fitToHeight: 5,
              fitToWidth: 7
            },
            views: [{
              state: 'frozen',
              ySplit: 2
            }]
          }); //set title table
          titleCell = worksheet.getCell('A1');
          titleCell.style = {
            font: {
              color: {
                argb: 'ffFF6600'
              },
              size: 16,
              bold: true
            }
          };
          titleCell.value = "\u30AE\u30D5\u30C8\u30FB\u30B5\u30F3\u30D7\u30EB\u7BA1\u7406\u8868 B\u1EA2NG QU\u1EA2N L\xDD H\xC0NG T\u1EB6NG, H\xC0NG M\u1EAAU ".concat(fromDate, "-").concat(toDate);
          worksheet.mergeCells('A1:I1');
          //
          //add table
          startTableRow = 1;
          startTable = worksheet.getCell("A".concat(startTableRow++));
          startTable.style = {
            font: {
              color: {
                argb: "ffff0202"
              }
            }
          };
          newData = (0, _lodash.orderBy)(data, ['createdAt'], ['asc']);
          generateTable(worksheet, newData, startTableRow, type);
          generateTableQuantitySKU(worksheet, newData, row + 2, type);
          _context.next = 16;
          return workbook.xlsx.writeBuffer();
        case 16:
          buffer = _context.sent;
          fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          fileExtension = ".xlsx";
          blob = new Blob([buffer], {
            type: fileType
          });
          (0, _fileSaver.saveAs)(blob, fileName + fileExtension);
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function exportGiveawayExcel(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var generateTable = function generateTable(worksheet, data, startTableRow, type) {
  //transform data
  var total = {
    quantity: 0,
    wholesalePrice: 0,
    beforeVatPrice: 0,
    vatPrice: 0,
    totalPrice: 0,
    costing: 0,
    shippingChargeByShiratori: 0,
    profit: 0
  };
  var giveaways = [];
  data.forEach(function (giveaway) {
    giveaway.giveawayDetails.forEach(function (e) {
      if (type == 'accountant' && !e.isPublished) {
        return;
      }
      var tmp = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, giveaway), {}, {
        lotNumber: e.lotNumber,
        product: e.product,
        productQuantity: e.quantity,
        rowspan: 0,
        // receiverFullAddress: giveaway.customer ? `${giveaway.customer.receiverAddress} ${giveaway.customer.receiverWardName
        //   } ${giveaway.customer.receiverDistrictName
        //   } ${giveaway.customer.receiverCityName}` : '',
        receiverFullAddress: giveaway.customer ? "".concat(giveaway.receiverAddress, " ").concat(giveaway.receiverWardName, " ").concat(giveaway.receiverDistrictName, " ").concat(giveaway.receiverCityName) : ''
      });
      giveaways.push(tmp);
    });
  });
  var count = 0;
  giveaways.forEach(function (element, index) {
    count++;
    if (index < giveaways.length - 1 && element.id != giveaways[index + 1].id) {
      giveaways[index + 1 - count].rowspan = count;
      count = 0;
    }
  });
  if (giveaways.length) {
    giveaways[giveaways.length - count].rowspan = count;
  }
  // giveaways.push({
  //   code: "Total",
  //   rowspan: 0
  // });
  var startRow = startTableRow;
  var dataExcel = [{
    value: "Date",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "createdAt",
    format: 'date',
    width: 12,
    mergeRow: true
  }, {
    value: "Customer Name",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "receiverName",
    width: 12,
    mergeRow: true
  }, type != 'accountant' && {
    value: "Phone",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "receiverPhone",
    width: 25,
    mergeRow: true
  }, {
    value: "Address",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "receiverFullAddress",
    width: 25
  }, {
    value: "Staff",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'staff.name',
    width: 20
  }, {
    value: "Purpose",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "purpose",
    width: 25
  }, {
    value: "SKU",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "product.sku",
    width: 25
  }, {
    value: "Lot Number",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "lotNumber",
    width: 20
  }, {
    value: "Order quantity (box)",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "productQuantity",
    numFmt: '#,##0',
    width: 8
  }];
  dataExcel = dataExcel.filter(function (e) {
    return !!e;
  });
  if (type == 'accountant') {
    dataExcel.push({
      value: "INVOICE NO",
      style: (0, _objectSpread2.default)({}, fontBold),
      prop: "invoice",
      width: 15
    });
  }
  var char = "A";
  var excludeProps = ['receiverName', 'receiverPhone', 'receiverFullAddress'];
  dataExcel.forEach(function (element) {
    var style = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, element.style), {}, {
      border: border,
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'ffff01'
        },
        bgColor: {
          argb: 'ffff01'
        }
      },
      alignment: {
        wrapText: true,
        vertical: 'middle'
      }
    });
    worksheet.getCell("".concat(char).concat(startRow)).style = style;
    worksheet.getCell("".concat(char).concat(startRow + 1)).style = style;
    worksheet.getCell("".concat(char).concat(startRow)).value = element.value;
    if (element.prop == 'receiverName') {
      worksheet.mergeCells("".concat(char).concat(startRow, ":").concat((0, _string.nextChar)(char, type != 'accountant' ? 2 : 1)).concat(startRow));
    }
    if (excludeProps.includes(element.prop)) {
      worksheet.getCell("".concat(char).concat(startRow)).value = "Customer";
      worksheet.getCell("".concat(char).concat(startRow + 1)).value = element.value;
    }
    row = startRow + 2;
    giveaways.forEach(function (order, index) {
      var rowIndex = startRow + index + 2;
      worksheet.getRow(rowIndex).height = 50;
      worksheet.getCell("".concat(char).concat(rowIndex)).style = {
        border: border,
        alignment: {
          vertical: 'middle'
        }
      };
      var value = (0, _index.generateProp)(order, element.prop, element.format);
      element.numFmt && (worksheet.getCell("".concat(char).concat(rowIndex)).numFmt = element.numFmt);
      if (typeof value == 'boolean') {
        value = value ? "〇" : "X";
        worksheet.getCell("".concat(char).concat(rowIndex)).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };
      }
      // if (element.mergeRow && order.rowspan) {
      //   worksheet.mergeCells(`${char}${rowIndex}:${char}${rowIndex - 1 + order.rowspan}`);
      // }
      if (order.code == 'Total') {
        worksheet.getCell("".concat(char).concat(rowIndex)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {
            argb: 'ffff01'
          },
          bgColor: {
            argb: 'ffff01'
          }
        };
        if (element.prop == 'code') {
          worksheet.mergeCells("".concat(char).concat(rowIndex, ":").concat((0, _string.nextChar)(char, 3)).concat(rowIndex));
        }
      }
      worksheet.getCell("".concat(char).concat(rowIndex)).value = value;
      row = rowIndex;
    });
    char = (0, _string.nextChar)(char);
  });
  worksheet.columns.forEach(function (e, i) {
    if (dataExcel[i]) e.width = dataExcel[i].width;
  });
};
var generateTableQuantitySKU = function generateTableQuantitySKU(worksheet, data, startTableRow, type) {
  var orders = {
    colsProducts: {
      "": ""
    },
    rowDate: {}
  };
  data.forEach(function (giveaway) {
    var giveawayDetails = (0, _lodash.sortBy)(giveaway.giveawayDetails, 'isPublished');
    giveawayDetails.forEach(function (e) {
      if (type == 'accountant' && !e.isPublished) {
        return;
      }
      orders["colsProducts"][e.product.sku] = 0;
    });
  });
  var total = (0, _objectSpread2.default)({}, orders["colsProducts"]);
  data.forEach(function (giveaway) {
    var giveawayDetails = (0, _lodash.sortBy)(giveaway.giveawayDetails, 'isPublished');
    giveawayDetails.forEach(function (e) {
      if (type == 'accountant' && !e.isPublished) {
        return;
      }
      var date = (0, _moment.default)(giveaway.createdAt * 1000).format("MM/YYYY");
      var nameProduct = e.product.sku;
      if (!orders["rowDate"][date]) {
        orders["rowDate"][date] = (0, _objectSpread2.default)({}, orders["colsProducts"]);
      }
      orders["rowDate"][date][nameProduct] += e.quantity;
      total[nameProduct] += e.quantity;
    });
  });
  orders["rowDate"]["Total"] = total;
  var startRow = startTableRow;
  var char = "A";
  Object.entries(orders.colsProducts).forEach(function (element, indexCol) {
    var rowIndex = startRow + indexCol + 1;
    worksheet.getCell("".concat(char).concat(rowIndex)).value = !indexCol ? "" : element[0];
    worksheet.getCell("".concat(char).concat(rowIndex)).style = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, fontBold), {}, {
      border: border,
      alignment: {
        wrapText: true,
        vertical: 'middle'
      }
    });
    // char = nextChar(char);
  });
  Object.entries(orders.rowDate).forEach(function (order, index) {
    Object.entries(order[1]).forEach(function (quantity, quantityIndex) {
      var rowIndex = startRow + quantityIndex + 1;
      worksheet.getCell("".concat((0, _string.nextChar)(char, index + 1)).concat(rowIndex)).value = !quantityIndex ? order[0] : quantity[1];
      worksheet.getCell("".concat((0, _string.nextChar)(char, index + 1)).concat(rowIndex)).style = {
        border: border,
        alignment: {
          vertical: 'middle'
        }
      };
    });
  });
};